export default ({...props}) => {
  const {themeGrey} = props.theme
  return `
    &[ap_atom_name="apModalAtom"]{
       background-color:${themeGrey.input_active}; 
    } 

    @media screen and (max-width: 768px) {
      &[ap_atom_name="apModalAtom"]{
        display: flex;
        flex-wrap: wrap;
        flex-grow: 1;
        flex-direction: column;
     } 
    }
  `
}

export const modalBoxStyles = ({...props}) => {
  const {palette, size, space} = props.theme
  return `
    position: absolute;
    top: 50%;
    left: 50%;
    width: ${size(62.5)}px;
    transform: translate(-50%, -50%);
    padding: ${size(2.5)}px;
    background-color: ${palette.common.white};
    height: auto;
    max-height: ${size(10)}vh;
    overflow-y: auto;

    ::-webkit-scrollbar {
      width: ${size(2)}px;
    }
    
    ::-webkit-scrollbar-track {
      background-color: transparent;
    }
    
    ::-webkit-scrollbar-thumb {
      background-color: #d6dee1;
      border-radius: ${space(2)}px;
      border: 6px solid transparent;
      background-clip: content-box;
    }
    
    @media only screen and (max-width:768px) {
     


      display: flex;
      flex-direction: column;
      flex-grow: 1;
      > form {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
      }
    } 

    .MuiGrid-root{
        padding-left:0px;
        padding-bottom:0px;
        & .MuiIconButton-root{
            padding-left:0px;
        }
        & .MuiTypography-root{
            margin-bottom:0px;
        }
    }
      
    .MuiInputBase-multiline{
        background-color:${palette.common.white};
        border: 1px solid ${palette.common.black};
        border-bottom:none;
        padding:0px;
        &:focus,
        &:hover,
        &:active {
            background-color:${palette.common.white}; 
            color:${palette.common.white};
        }
        &.Mui-focused{
            background-color:${palette.common.white};
        }
    }
    & > .MuiInputBase-inputMultiline{
        padding:0px;
    }


    @media screen and (max-width: 768px) {
      flex-grow: 1; 
      width: ${size(12.5)}%;
      height: ${size(12.5)}%;
      max-height: ${size(12.5)}%;
      display: flex;
    }
  `
}

// width: ${size(12.5)}%;
// height: ${size(12.5)}%;
// max-height: ${size(12.5)}%;
